import { render, staticRenderFns } from "./PartSearchFacetsExpand.vue?vue&type=template&id=568ecae4"
import script from "./PartSearchFacetsExpand.vue?vue&type=script&lang=js"
export * from "./PartSearchFacetsExpand.vue?vue&type=script&lang=js"
import style0 from "./PartSearchFacetsExpand.vue?vue&type=style&index=0&id=568ecae4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports